// import api from "../../../../BasicComponent/Service/api";
// import { CHECKLIST_BINDING_URL } from "../../../utils/constService";

// export const fetchBindings = (params = {}) =>
//   api.get(CHECKLIST_BINDING_URL, { params });

// export const fetchBindingByUuid = (uuid) =>
//   api.get(`${CHECKLIST_BINDING_URL}/${uuid}`);

// export const postBinding = (data) =>
//   api.post(CHECKLIST_BINDING_URL, data);

// export const putBinding = (uuid, data) =>
//   api.put(`${CHECKLIST_BINDING_URL}/${uuid}`, data);

// export const deleteBinding = (uuid) =>
//   api.delete(`${CHECKLIST_BINDING_URL}/${uuid}`);

// /**
//  * Fetch aggregated report for a binding + a specific unit (serial/PO/model).
//  */
// export const fetchBindingReport = (uuid, { serialNumber, poNumber, modelNumber }) =>
//   api.get(`${CHECKLIST_BINDING_URL}/${uuid}/report`, {
//     params: { serialNumber, poNumber, modelNumber },
//   });

// /**
//  * Fetch combined analysis for a binding — real numbered pagination (page 1 =
//  * most recent batch). `page` and `asOf` combine rather than override each
//  * other: `asOf` (epoch millis) makes the WHOLE pagination act as if that were
//  * "now" — totalPages/totalRecords shrink to match what existed then — and
//  * `page` still selects which page within that view. Omit `asOf` for the live
//  * view (today's actual current time).
//  */
// export const fetchBindingAnalysis = (uuid, limit = 100, page = 1, asOf) =>
//   api.get(`${CHECKLIST_BINDING_URL}/${uuid}/analysis`, {
//     params: { limit, page, ...(asOf ? { asOf } : {}) },
//   });

import api from "../../../../BasicComponent/Service/api";
import { CHECKLIST_BINDING_URL } from "../../../utils/constService";

export const fetchBindings = (params = {}) =>
  api.get(CHECKLIST_BINDING_URL, { params });

export const fetchBindingByUuid = (uuid) =>
  api.get(`${CHECKLIST_BINDING_URL}/${uuid}`);

export const postBinding = (data) =>
  api.post(CHECKLIST_BINDING_URL, data);

export const putBinding = (uuid, data) =>
  api.put(`${CHECKLIST_BINDING_URL}/${uuid}`, data);

export const deleteBinding = (uuid) =>
  api.delete(`${CHECKLIST_BINDING_URL}/${uuid}`);

/**
 * Fetch aggregated report for a binding + a specific unit (serial/PO/model).
 */
export const fetchBindingReport = (uuid, { serialNumber, poNumber, modelNumber }) =>
  api.get(`${CHECKLIST_BINDING_URL}/${uuid}/report`, {
    params: { serialNumber, poNumber, modelNumber },
  });

/**
 * Fetch combined analysis for a binding — real numbered pagination (page 1 =
 * most recent batch). `page` and `asOf` combine rather than override each
 * other: `asOf` (epoch millis) makes the WHOLE pagination act as if that were
 * "now" — totalPages/totalRecords shrink to match what existed then — and
 * `page` still selects which page within that view. Omit `asOf` for the live
 * view (today's actual current time).
 */
export const fetchBindingAnalysis = (uuid, limit = 100, page = 1, asOf) =>
  api.get(`${CHECKLIST_BINDING_URL}/${uuid}/analysis`, {
    params: { limit, page, ...(asOf ? { asOf } : {}) },
  });